import { DOMUtils } from '../../../../utils/dom'
import { Mixin } from '../../../../utils/mixin'

import {
    IIdentityProviderConfig,
    IIdentityServiceAdapter,
    ISubscriberProviderConfig
} from '../adapter'

import { IdentityService } from '../..'
import {
    ICommentAdConfiguration
} from '../../../../domain/conf/ads'
import { AdDOM } from '../../../ads/ad'
import { AdEvents } from '../../../ads/ad/events'
import { AdRefreshDOM } from '../../../ads/refresh'

interface ICommentAttr {
    key: string
    value: string
}

interface IWindow {
    vf: any
    vfQ: any
}

declare let window: IWindow
export const WithViafoura = <T extends Mixin<IIdentityServiceAdapter<IIdentityProviderConfig>>>(Base: T) =>
    class extends Base implements IIdentityServiceAdapter<IIdentityProviderConfig> {
        public el: HTMLElement
        public adCommentDOM = {
            attrs: {
                mobileSize: 'data-comments-ad-size-mobile',
                ref: 'data-comments-ad-ref',
                size: 'data-comments-ad-size',
                target: 'data-comments-ad-target',
                viafouraAd: 'data-ad-comment'
            },
            classes: {
                adContainer: 'ad__inner__container',
                adLight :'ad__adlight'
            }
        }
        public adLight: boolean
        private adCommentAttrs: ICommentAttr[]
        private adCounter = 0
        private DOM = {
            attrs: {
                class: 'viafoura',
                jsUrl: '//cdn.viafoura.net/vf-v2.js',
                vfConversations: 'vf-conversations',
                vfDropdownItem: 'vf-dropdown__list-item',
                vfTrayTrigger: 'vf-tray-trigger',
                wrapper: 'data-sso-commenting'
            },
        }

        private firstPromoPosition = '1'
        private promoInterval = '10'

        private viafouraClickListeners: { [key: string]: (...args: any[]) => void } = {
            'trending-list__title': this.displayConsole,
            'vf-js-tray-activator': this.displayConsole
        }

        public enable() {
            this.addSubscriptions()
            this.addListeners()
        }

        public generateCommentAd(slotName: string) {
                this.initCommentAds(slotName)
        }

        public initCommentAds(slotName: string) {
            if (DOMUtils.idElementExists(`${slotName}`)) {
                const el = document.getElementById(`${slotName}`)
                this.insertAdMarkup(el,this.adCounter = this.adCounter+1, slotName)
                this.registerCommentAds(slotName)
            }
        }

        public registerCommentAds(slotName: string) {
            const el = DOMUtils.nodes(document.querySelector(`#${slotName} [${this.adCommentDOM.attrs.viafouraAd}]`))
            dispatchEvent(new CustomEvent(AdEvents.SLOT_ADDED, {
                detail: {
                    el,
                }
            }))
        }

        public insertCommentAd(count: string) {
            const ad = document.createElement('div')
            ad.setAttribute(AdDOM.attr.location.key, count)
            this.adCommentAttrs.forEach((_: any) => {
                ad.setAttribute(_.key, _.value)
            })
            return ad
        }

        public insertAdMarkup(el: Element, count: number, slotName: string) {
            const ad = document.createElement('div')
            ad.id = `${slotName}`
            ad.setAttribute(DOMUtils.attrs.class,`${IdentityService.DOM.class.adContainer}`)
            ad.append(this.insertCommentAd(`${count}`))
            el.appendChild(ad)
        }

        public initAdMarkup() {
            if(this.el) {
                this.adCommentAttrs = [
                    {
                        key: DOMUtils.attrs.class,
                        value: this.adCommentDOM.classes.adContainer
                    },
                    {
                        key: AdDOM.attr.target.key,
                        value: this.el.getAttribute(this.adCommentDOM.attrs.target)
                    },
                    {
                        key: AdDOM.attr.size.key,
                        value: this.el.getAttribute(this.adCommentDOM.attrs.size)
                    },
                    {
                        key: AdDOM.attr.mobileSize.key,
                        value: this.el.getAttribute(this.adCommentDOM.attrs.mobileSize)
                    },
                    {   key: AdRefreshDOM.attr.state.key,
                        value: this.el.getAttribute(this.adCommentDOM.attrs.ref)
                    },
                    {   key: `${this.adCommentDOM.attrs.viafouraAd}`,
                        value: ''
                    }
                ]
            }
        }

        public addSubscriptions() {
            window.vfQ.push(() => {
                window.vf.$subscribe('vf-ads', 'requestCommentAd',
                    this.generateCommentAd.bind(this))

                window.vf.$subscribe('logout', 'success', () => {
                    this.signOut()
                })

                window.vf.$prepublish((channel: string, event: string, ...args: object[]) => {
                    if (channel === 'authentication' && event === 'required') {
                        super.signIn()
                        return false
                    }

                    return { channel, event, args }
                })
            })
        }

        public addListeners() {
            document.addEventListener('click', (e: Event) => {
                const el = e.target as Element
                for (const target in this.viafouraClickListeners) {
                    if (el.classList.contains(target)) {
                        this.eventFunction(this.viafouraClickListeners[target], target)
                    }
                }
            })
        }

        public removeCommentAdUI() {
            if(document.querySelector(`[${this.DOM.attrs.wrapper}]`)) {
                DOMUtils.addClass(document.querySelector(`[${this.DOM.attrs.wrapper}]`),
                `${this.adCommentDOM.classes.adLight}`)
            }
        }

        public signIn() {
            super.signIn()
        }
        public signOut() {
            super.signOut()
        }
        public displayConsole(target: string) {
            console.log('target: ', target)
        }
        public eventFunction(event: any, target: string) {
            event(target)
        }

        public initialize(
            conf: ISubscriberProviderConfig,
            ssoCreds: IIdentityProviderConfig,
            isPremium = false,
            isPaywallWhitelisted = false,
            commentAdConfiguration?: ICommentAdConfiguration
        ) {

            if (commentAdConfiguration) {
                this.firstPromoPosition = commentAdConfiguration.firstPromoPosition ?
                    commentAdConfiguration.firstPromoPosition : '1'
                this.promoInterval = commentAdConfiguration.promoInterval ?
                    commentAdConfiguration.promoInterval : '10'
            }

            if (!!window.vfQ) {
                return this
            }

            window.vf = window.vf || { events: {} }
            window.vfQ = window.vfQ || []
            this.loadViafouraUI()
                .then(async () => {
                    await this.scriptLoad()
                    this.addListeners()
                    window.vfQ.push(() => {
                        console.log('window.vf.* is now ready')
                        this.enable()
                    })
                })
                .catch(console.error)

            // register `ready` handlers
            // calls WithPiano intialize() method
            super.initialize(conf, ssoCreds, isPremium, isPaywallWhitelisted)
            return this
        }
        public async scriptLoad(): Promise<boolean> {
            try {
                DOMUtils.loadScript(this.DOM.attrs.jsUrl)
                return true
            } catch (e) {
                return false
            }
        }
        protected async loadViafouraUI() {
            try {
                await DOMUtils.ready // wait for DOM
                await this.hasSession()

                /**
                 * Add stylesheet
                 */
                const scss = import('./styles/viafoura.scss')
                DOMUtils.addStyles((await scss).default)

                /**
                 * Add viafoura containers
                 */
                console.log('Load Viafoura UI')
                const viafoura: HTMLElement = document.createElement('div')

                DOMUtils.addClass(viafoura, this.DOM.attrs.class)

                /* note, order matters - vfTrayTrigger must come after conversations container */
                const conversationsContainer = document.createElement(this.DOM.attrs.vfConversations)
                conversationsContainer.setAttribute('first-promo-position', this.firstPromoPosition)
                conversationsContainer.setAttribute('promo-interval', this.promoInterval)

                viafoura.appendChild(conversationsContainer)

                viafoura.appendChild(document.createElement(this.DOM.attrs.vfTrayTrigger))
                const pluginContainers = document.querySelectorAll(`[${this.DOM.attrs.wrapper}]`)
                this.el = document.querySelector(`[${this.DOM.attrs.wrapper}]`)

                pluginContainers.forEach((container) => {
                    container.appendChild(viafoura)
                    console.log('Load Viafoura UI::appendChild', container)
                })

                this.initAdMarkup()

            } catch (e) {
                console.error('FEM.Identity.Janrain unable to load CSS/HTML for templates:', e)
            }
        }
    }
